import { Header } from "@tanstack/react-table";
import { Box, Flex, Chip } from "@mantine/core";
import { formatISO } from "date-fns";

type AppliedfiltersProps<T> = {
  headers: Header<T, any>[];
};

export default function AppliedFilters<T>({ headers }: AppliedfiltersProps<T>) {
  const appliedFilters = headers.filter((h) => h.column.getIsFiltered());

  if (appliedFilters.length === 0) return <div />;

  return (
    <Box
      sx={(theme) => ({
        backgroundColor:
          theme.colorScheme === "dark"
            ? theme.colors.gray[9]
            : theme.colors.gray[0],
        color:
          theme.colorScheme === "dark"
            ? theme.colors.gray[6]
            : theme.colors.gray[5],
        padding: theme.spacing.xs,
        borderRadius: theme.radius.md,
      })}
    >
      Applied Filters
      <Flex
        gap={4}
        wrap="wrap"
        sx={(theme) => ({ marginTop: theme.spacing.xs })}
      >
        {appliedFilters.map((header) => {
          let filterValue = header.column.getFilterValue();
          if (Array.isArray(filterValue)) {
            const dates = filterValue
              .filter((v) => v)
              .map((v) => {
                // Handle JST formatted strings (e.g., "2025-08-24T00:00:00+09:00" or "2025-08-24T00:00:00 09:00")
                if (typeof v === 'string' && v.includes('T') && v.includes('+09:00')) {
                  // Extract just the date part from JST string
                  return v.split('T')[0];
                }
                
                let dateStr = v;
                if (typeof v === 'string' && v.includes(' 09:00')) {
                  dateStr = v.replace(' 09:00', '+09:00');
                }
                
                const date = new Date(dateStr);
                // Check if the date is valid
                if (isNaN(date.getTime())) {
                  return v; // Return original value if not a valid date
                }
                return formatISO(date, { representation: "date" });
              });
            
            // If both dates are the same, show only one date
            if (dates.length === 2 && dates[0] === dates[1]) {
              filterValue = dates[0];
            } else {
              filterValue = dates.join("..");
            }
          }

          return (
            <Chip
              key={header.id}
              defaultChecked
              color="cyan"
              variant="outline"
              onChange={(checked) => {
                if (!checked) header.column.setFilterValue(null);
              }}
            >
              <span>
                <b>{header.column.columnDef.header as string}:</b>&nbsp;
                {filterValue as string}
              </span>
            </Chip>
          );
        })}
      </Flex>
    </Box>
  );
}
